import React, { useState, useMemo, useEffect } from 'react'
import { DrawerCreditOptions, RectangleSkeleton } from '@sainsburys-tech/bolt'
import MonthlyPaymentsTable from '../FinanceDrawer/MonthlyPaymentsTable'
import { getPreferredCreditPlans } from '../../../../helpers/creditPlanHelper'
import * as Styled from './FinanceProviderCustomWidget.styles'

const FinanceProviderCustomWidget = ({ creditPlansV5 }) => {
  const [showDrawer, setShowDrawer] = useState(false)

  const toggleDrawer = show => {
    setShowDrawer(show)
  }

  const { qualifyingCreditPlans } = useMemo(() => getPreferredCreditPlans(creditPlansV5 || []), [creditPlansV5])

  const selectedPlan = qualifyingCreditPlans[0] || null

  if (!creditPlansV5 || qualifyingCreditPlans.length === 0) {
    return <RectangleSkeleton height={44} width={350} />
  }

  useEffect(() => {
    window.digitalData.page.attributes.creditOffered.push('paypalIBC')
  }, [])

  return (
    <Styled.WidgetContainer data-test='widget-container' onClick={() => !showDrawer && toggleDrawer(true)}>
      <Styled.LabelImage
        src='//media.4rgos.it/i/Argos/ifc-paypal-credit'
        width='64'
        height='40'
        data-test='paypal-credit-image'
        alt='paypal-credit-image'
      />
      <Styled.TextContainer data-test='text-container'>
        {selectedPlan?.periodicPayment !== undefined &&
          `£${selectedPlan.periodicPayment?.toFixed(2)} per month at ${selectedPlan.apr}% interest over ${
            selectedPlan.periodDuration
          } months. `}

        {qualifyingCreditPlans.length > 0 && <Styled.Link data-test='learn-more-link'>Learn more</Styled.Link>}
      </Styled.TextContainer>

      {qualifyingCreditPlans.length > 0 && (
        <DrawerCreditOptions
          monthlyPaymentsTable={<MonthlyPaymentsTable plans={qualifyingCreditPlans} />}
          show={showDrawer}
          onClose={() => toggleDrawer(false)}
          data-test='drawer-credit-options'
        />
      )}
    </Styled.WidgetContainer>
  )
}

export default FinanceProviderCustomWidget
